import { API, setAuthToken } from '../../../config/API.js';
import {
  GET_DATA_ASET,
  GET_TIPE_ASET,
  SET_LOADING_DATA_ASET,
  SET_LOADING_TIPE_ASET,
  SET_PAGINATION_DATA_ASET,
  SET_PAGINATION_TIPE_ASET,
} from '../constant.js';

export const getTipeAset = (params) => {
  return (dispatch) => {
    const token = localStorage.getItem("jwt_token");
    setAuthToken(token);
    dispatch({
      type: SET_LOADING_TIPE_ASET,
      payload: true,
    });
    API.get(
      `admin/property/investment/type?${new URLSearchParams(params).toString()}`
    )
      .then((res) => {
        dispatch({
          type: GET_TIPE_ASET,
          payload: params?.paginate === false ? res?.data : res.data.data || [],
        });
        dispatch({
          type: SET_PAGINATION_TIPE_ASET,
          payload: res?.data?.data?.last_page,
        });
      })
      .catch(() => {
        dispatch({
          type: GET_TIPE_ASET,
          payload: [],
        });
        dispatch({
          type: SET_PAGINATION_TIPE_ASET,
          payload: 0,
        });
      });
  };
};

export const addTipeAset = (params) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.post("admin/property/investment/type/add", params);
};

export const getDetailTipeAset = (code) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.get(`admin/property/investment/type/${code}`);
};

export const updTipeAset = (params) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.post("admin/property/investment/type/edit", params);
};

export const delTipeAset = (code) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.delete("admin/property/investment/type/delete/" + code);
};

export const getDataAset = (params) => {
  return (dispatch) => {
    const token = localStorage.getItem("jwt_token");
    setAuthToken(token);
    dispatch({
      type: SET_LOADING_DATA_ASET,
      payload: true,
    });
    API.get(
      `admin/property/investment?${new URLSearchParams(params).toString()}`
    )
      .then((res) => {
        dispatch({
          type: GET_DATA_ASET,
          payload: params?.paginate === false ? res?.data : res.data.data || [],
        });
        dispatch({
          type: SET_PAGINATION_DATA_ASET,
          payload: res?.data?.data?.last_page,
        });
      })
      .catch(() => {
        dispatch({
          type: GET_DATA_ASET,
          payload: [],
        });
        dispatch({
          type: SET_PAGINATION_DATA_ASET,
          payload: 0,
        });
      });
  };
};

export const addDataAset = (params) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.post("admin/property/investment/add", params);
};

export const getDetailDataAset = (code) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.get(`admin/property/investment/${code}`);
};

export const updDataAset = (params) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.post("admin/property/investment/edit", params);
};

export const delDataAset = (code) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.delete("admin/property/investment/delete/" + code);
};
